import type { TenantConfig } from '@/types/TenantConfig'

export const lincolnhill: TenantConfig = {
  logo: 'assets/lincolnhill/static/logo.png',
  themeOptions: {
    dialog: {
      headerBackground: '#fbf8ed',
    },
  },
  teaserImageSize: {
    height: 200,
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;1,300&family=Sorts+Mill+Goudy:ital@0;1&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        percentFees: 'Sales Tax/Administrative/Ticketing Fees',
      },
    },
  },
}
